export default function (context, value) {
    let data = context.getters.data;
    if (!data) return;
    context.commit('set', {loading: true});
    axios({
        url: '/tourclient/payment/' + (context.state.Id ? 'update' : 'add'),
        method: 'post',
        data: 'request=' + JSON.stringify({
            PaymentItem: data
        })
    }).then(({data}) => {
        context.commit('set', {loading: false});
    })
}
